import { Maybe } from '../../../__generated__/globalTypes'

import awardFragmentRawString from '../AwardFragment.graphql'

export const awardFragmentString = awardFragmentRawString

export type AwardFragment = {
  id: string
  title: string
  iconUrl: string
  description: string
  checklist: string[]
  progress: number
  threshold: number
  graphicUrl: string
  checklistTitle: string
  checklistSubtitle: string
  completedDescription: string
  incrementalProgress: Maybe<{
    count: number
    icon: string
    title: string
  }>
}

export const isAwardFragment = (fragment: any): fragment is AwardFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.iconUrl === 'string' &&
  typeof fragment.description === 'string' &&
  Array.isArray(fragment.checklist) &&
  fragment.checklist
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && typeof next === 'string',
      true,
    ) &&
  typeof fragment.progress === 'number' &&
  typeof fragment.threshold === 'number' &&
  typeof fragment.graphicUrl === 'string' &&
  typeof fragment.checklistTitle === 'string' &&
  typeof fragment.checklistSubtitle === 'string' &&
  typeof fragment.completedDescription === 'string' &&
  (fragment.incrementalProgress === null ||
    (fragment.incrementalProgress &&
      typeof fragment.incrementalProgress.count === 'number' &&
      typeof fragment.incrementalProgress.icon === 'string' &&
      typeof fragment.incrementalProgress.title === 'string'))
